import React, { useState } from "react";
import DeleteDialog from "../../../components/DeleteDialog";

const DeleteHeroBanner = ({ open, recordId, handleClose, handleDelete }) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteAction = async () => {
    setLoading(true);
    await handleDelete(recordId).then(() => {
      setLoading(false);
    });
  };

  return (
    <DeleteDialog
      handleClose={handleClose}
      handleDelete={handleDeleteAction}
      loading={loading}
      open={open}
      title="Delete Banner"
    />
  );
};

export default DeleteHeroBanner;
